import type { InvivoRenderSettings } from "../types/invivo_scene";

export function applyRenderSettingsRuntime({
  scene,
  camera,
  renderSettings,
}: {
  scene: unknown;
  camera: unknown;
  renderSettings: InvivoRenderSettings;
}): void {
  const { BABYLON } = window;

  if (!BABYLON.DefaultRenderingPipeline) {
    return;
  }

  const pipeline = new BABYLON.DefaultRenderingPipeline("Invivo::rendering_pipeline", true, scene, [camera]);

  if (!pipeline.imageProcessing) {
    return;
  }

  if (BABYLON.ColorCurves && renderSettings.imageProcessing.colorCurves) {
    pipeline.imageProcessing.colorCurves = new BABYLON.ColorCurves();
    Object.assign(pipeline.imageProcessing.colorCurves, renderSettings.imageProcessing.colorCurves);
  }

  Object.assign(pipeline.imageProcessing, {
    colorCurvesEnabled: renderSettings.imageProcessing.colorCurvesEnabled,
    exposure: renderSettings.imageProcessing.exposure,
    contrast: renderSettings.imageProcessing.contrast,
  });

  if (pipeline.sharpen) {
    pipeline.sharpen.colorAmount = renderSettings.sharpen.colorAmount;
    pipeline.sharpen.edgeAmount = renderSettings.sharpen.edgeAmount;
  }
  pipeline.sharpenEnabled = renderSettings.sharpen.enabled;

  if (pipeline.bloom) {
    pipeline.bloom.weight = renderSettings.bloom.weight;
  }
  pipeline.bloomEnabled = renderSettings.bloom.enabled;

  if (pipeline.grain) {
    pipeline.grain.intensity = renderSettings.grain.intensity;
    pipeline.grain.animated = renderSettings.grain.animated;
  }
  pipeline.grainEnabled = renderSettings.grain.enabled;

  if (pipeline.chromaticAberration) {
    pipeline.chromaticAberration.aberrationAmount = renderSettings.chromaticAberration.amount;
  }
  pipeline.chromaticAberrationEnabled = renderSettings.chromaticAberration.enabled;
  pipeline.depthOfFieldEnabled = renderSettings.depthOfFieldEnabled;
}
